import React, { FC, FocusEvent } from "react";
import Modal from "react-modal";
import { CloseButton } from "../Booking/CloseButton/CloseButton";
import { EditableWaitlistViewModel } from "../../Blocks/Waitlist/EditableWaitlistViewModel.csharp";
import { UpdateWaitlistCheckbox } from "./UpdateWaitlistCheckbox";

type UpdateWaitlistConfirmationModalProps = {
  onClose: () => void;
  onSubmit: () => void;
  isOpen: boolean;
  reasons: string[];
  toggleReason: (value: string) => void;
  setAdditionalReason: (value: string) => void;
  alert: boolean;
  setAlert: (value: boolean) => void;
  waitlist: EditableWaitlistViewModel;
};

export const UpdateWaitlistConfirmationModal: FC<
  UpdateWaitlistConfirmationModalProps
> = ({
  onClose,
  onSubmit,
  isOpen,
  reasons,
  toggleReason,
  setAdditionalReason,
  alert,
  setAlert,
  waitlist,
}) => {
  const handleBlur = (e: FocusEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    setAdditionalReason(value);
  };

  const getChangeReasons = () => {
    return waitlist.closeTodaysRegistration
      ? waitlist.openingReasons
      : waitlist.closingReasons;
  };

  const handleSelectChange = (selectedReason: string) => {
    toggleReason(selectedReason);
  };

  return (
    <Modal
      overlayClassName="react-modal__overlay"
      className="react-modal__content react-modal__content--additional"
      isOpen={isOpen}
    >
      <div className="confirm-modal__outer">
        <div className="confirm-modal__inner my-2 p-2 pt-1 fs-5">
          <CloseButton onClick={onClose} />
          <h4>{waitlist.editableWaitlistLabels.modalHeading}</h4>
          <div
            dangerouslySetInnerHTML={{
              __html: waitlist.editableWaitlistLabels.modalDescription,
            }}
          />

          <div className="fs-6 mb-0 mt-3">
            {getChangeReasons()?.map((reason, i) => (
              <UpdateWaitlistCheckbox
                key={i}
                onChange={() => {
                  handleSelectChange(reason);
                }}
                checked={reasons.indexOf(reason) !== -1}
                disabled={false}
                label={reason}
              />
            ))}
            <textarea
              className={"form-control mb-3 fs-5"}
              onBlur={handleBlur}
              placeholder={waitlist.additionalChangeReasonPlaceholder}
            />
            <UpdateWaitlistCheckbox
              onChange={() => {
                setAlert(!alert);
              }}
              checked={alert}
              disabled={!waitlist.isAlertAvailable}
              label={waitlist.editableWaitlistLabels.sendAlertLabel}
            />
          </div>
          <div className="d-flex justify-content-center mt-2">
            <button
              className="btn btn-primary"
              onClick={() => {
                onSubmit();
                onClose();
              }}
            >
              {waitlist.editableWaitlistLabels.modalSubmitLabel}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
